import {useEffect, useState} from "react";
import {getUserInfo, workflowResume} from "../../../services/auth";
import Loader from "../../../components/loader";
import {useAppContext} from "../../../helpers/hooks/common-hook";
import {AUTH_KEY, AUTH_REQUEST_STATE_KEY} from "../../../consts/common-consts";
import appConfig  from "../../../config";
import axios from "axios";
import qs  from 'qs';
import {useCookies} from "react-cookie";

export default function AuthSuccess({ authConfig, authInfo }) {
    const [cookies, setCookie] = useCookies(["cookie-name"]);
    const { accessKey } = JSON.parse(sessionStorage.getItem(AUTH_REQUEST_STATE_KEY));
    const [userInfo, setUserInfo] = useState();
    const [authCredentials, setAuthCredentials] = useState(null);
    const [authSuccess, setAuthSuccess] = useState(false);

    const [apiCallState, setApiCallState] = useState({
        processing: false,
        completed: false,
        success: false,
        failed: false,
        errorMessage: ''
    });

    const updateApiCallState = (processing, completed, success, failed, errorMessage) => {
        setApiCallState(Object.assign({}, { processing, completed, success, failed, errorMessage }))
    }

    async function fetchAccessToken() {
        try {
            let data = qs.stringify({
                grant_type: 'authorization_code',
                code: authInfo.code,
                redirect_uri: appConfig.AUTH_CALLBACK_URL,
                client_id: authConfig.clientId,
                scope: authConfig.scope.join(' ')
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: authConfig.tokenEndpoint,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data : data
            };

            const response = await axios.request(config)
            const { id_token, access_token, refresh_token } = response.data;
            setAuthCredentials({
                id_token,
                access_token
            })
        } catch (error) {
            console.error('Error fetching the token:', error);
        }
    }

    async function fetchUsrInfo() {
        updateApiCallState(true);
        const config = await getUserInfo(authConfig.userInfoEndpoint, authCredentials.access_token);
        if (config) {
            setUserInfo(config);
            updateApiCallState(false, true, true);
        } else {
            updateApiCallState(false, true, false, true, "Unable to load user info");
        }
    }

    async function setAuthContext() {
        updateApiCallState(true);
        const { appId, sessionId } = JSON.parse(sessionStorage.getItem(AUTH_REQUEST_STATE_KEY))
        const auth = { ...userInfo, credentials: authCredentials }
        setCookie(AUTH_KEY, auth, { path: '/' })
        const response = await workflowResume(appId,
            { sessionId, requestAttributes: {
                    auth
                } }, accessKey);
        if (response) {
            setAuthSuccess(true);
            updateApiCallState(false, true, true);
        } else {
            updateApiCallState(false, true, false, true, "Unable to authenticate. Please try again");
        }
    }

    useEffect(() => {
        if (authInfo) {
            fetchAccessToken();
        }
    }, [authInfo]);

    useEffect(() => {
        if (authCredentials) {
            fetchUsrInfo();
        }
    }, [authCredentials]);

    useEffect(() => {
        if (userInfo) {
            setAuthContext();
        }
    }, [userInfo]);

    return (
        <div className="px-2">

            {(apiCallState.completed && apiCallState.failed) &&
                <div>
                    <span className="flex flex-row text-sm text-red-500">{apiCallState.errorMessage}</span>
                </div>
            }

            {authSuccess &&
                <div className="flex flex-col">
                    <div className="flex flex-col">
                        <span className="text-sm text-gray-700">Login successful</span>
                    </div>
                </div>
            }

            {apiCallState.processing &&
                <div className="flex flex-row justify-center items-center py-4">
                    <Loader/>
                </div>
            }
        </div>

    )
};